<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="page3"></a>
<p class="title"><strong class="calibre1">Come Home to Death</strong></p>
<p class="au"><strong class="calibre1">A Patrick Dawlish Mystery</strong></p>
<p class="au"><strong class="calibre1">John Creasey <i>writing as</i> Gordon Ashe</strong></p>
<p class="au"><img alt="Logo" src="images/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000.vue?c586990a